import React from 'react';
import { Navigate } from 'react-router-dom';

const StudentProtectedRoute = ({ children }) => {
  const userData = localStorage.getItem('userData');
  const token = localStorage.getItem('token');
  
  // Check if logged in
  if (!userData || !token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default StudentProtectedRoute;